/**
 * Konko: código de descuento manual en el carrito (drawer y página de carrito).
 *
 * Reemplaza, solo dentro de este theme, el widget roto que inyecta el script
 * externo "konko-cro-v11.js" (Shopify > Contenido > Archivos, cargado vía
 * shop.metafields.loox["global_html_head"]). Ese archivo es compartido con
 * el theme publicado, por lo que NO se edita: este script detecta y elimina
 * su widget (".konko-disc" sin marca propia) e inserta el nuestro en su lugar.
 *
 * Mecanismo oficial usado: POST /cart/update.js con el parámetro "discount"
 * (Cart AJAX API, soporta aplicar y remover desde el mismo endpoint).
 * https://shopify.dev/changelog/cart-ajax-api-discounts-support-on-cartupdatejs
 *
 * La fuente de verdad es siempre la respuesta de Shopify (cart.discount_codes),
 * nunca un cálculo o texto simulado. localStorage solo se usa para recordar
 * el código mientras se revalida contra el carrito real.
 */
(function () {
  if (window.__kkCartDiscountBound) return;
  window.__kkCartDiscountBound = true;

  var STORAGE_KEY = 'kk_cart_disc_state';
  var MAX_AGE_MS = 24 * 60 * 60 * 1000;

  var MSG = {
    empty: 'Ingresa un código de descuento.',
    multiple: 'Ingresa un solo código de descuento.',
    validating: 'Validando código…',
    applied: 'Código aplicado.',
    notApplicable: 'Este código no aplica al carrito actual.',
    techError: 'No pudimos validar el código. Inténtalo nuevamente.'
  };

  var appliedCode = null;      // último código confirmado por Shopify (applicable true o false)
  var appliedOk = false;       // true solo si Shopify confirmó applicable === true
  var currentRequestId = 0;    // guard contra respuestas viejas pisando una más nueva
  var widgets = [];            // {root, input, btn, msg, removeBtn}

  // ---------- almacenamiento (solo ayuda visual, nunca prueba de aceptación) ----------
  function readState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.code || !obj.appliedAt) return null;
      if (Date.now() - obj.appliedAt > MAX_AGE_MS) return null;
      return obj;
    } catch (e) { return null; }
  }
  function writeState(code) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: code, appliedAt: Date.now() })); } catch (e) {}
  }
  function clearState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // ---------- red ----------
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('http_' + r.status);
      return r.json();
    });
  }
  function setCartDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) {
      if (!r.ok) throw new Error('http_' + r.status);
      return r.json();
    });
  }
  function findEntry(cart, code) {
    var list = (cart && cart.discount_codes) || [];
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].code).toUpperCase() === String(code).toUpperCase()) return list[i];
    }
    return null;
  }
  function hasMultipleCodes(raw) {
    return /[\s,;+]/.test(raw);
  }
  function broadcastCartChange() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  // ---------- render ----------
  function setMessage(w, text, tone) {
    w.msg.textContent = text || '';
    w.msg.style.color = tone === 'ok' ? '#1d3a2a' : (tone === 'error' ? '#c00' : '#555');
  }
  function setBusy(busy) {
    widgets.forEach(function (w) {
      w.btn.disabled = !!busy;
      w.input.disabled = !!busy;
    });
  }
  function forEachWidget(fn) { widgets.forEach(fn); }

  function renderIdle() {
    forEachWidget(function (w) {
      w.input.value = '';
      setMessage(w, '', null);
      w.removeBtn.style.display = 'none';
    });
  }
  function renderApplied(code) {
    forEachWidget(function (w) {
      w.input.value = '';
      setMessage(w, MSG.applied + ' (' + code + ')', 'ok');
      w.removeBtn.style.display = '';
    });
  }
  function renderNotApplicable(code) {
    forEachWidget(function (w) {
      w.input.value = '';
      setMessage(w, MSG.notApplicable, 'error');
      w.removeBtn.style.display = '';
    });
  }

  // ---------- lógica principal ----------
  function applyCode(raw) {
    raw = (raw || '').trim();
    if (!raw) { forEachWidget(function (w) { setMessage(w, MSG.empty, 'error'); }); return; }
    if (hasMultipleCodes(raw)) { forEachWidget(function (w) { setMessage(w, MSG.multiple, 'error'); }); return; }

    var code = raw;
    var myId = ++currentRequestId;
    setBusy(true);
    forEachWidget(function (w) { setMessage(w, MSG.validating, null); });

    setCartDiscount(code).then(function (cart) {
      if (myId !== currentRequestId) return; // llegó una respuesta más nueva primero, se ignora esta
      setBusy(false);
      var entry = findEntry(cart, code);
      appliedCode = code;
      writeState(code);
      if (entry && entry.applicable) {
        appliedOk = true;
        renderApplied(code);
      } else {
        appliedOk = false;
        renderNotApplicable(code);
      }
      broadcastCartChange();
    }).catch(function () {
      if (myId !== currentRequestId) return;
      setBusy(false);
      forEachWidget(function (w) { setMessage(w, MSG.techError, 'error'); });
    });
  }

  function removeCode() {
    var myId = ++currentRequestId;
    setBusy(true);
    setCartDiscount('').then(function () {
      if (myId !== currentRequestId) return;
      setBusy(false);
      appliedCode = null;
      appliedOk = false;
      clearState();
      renderIdle();
      broadcastCartChange();
    }).catch(function () {
      if (myId !== currentRequestId) return;
      setBusy(false);
      forEachWidget(function (w) { setMessage(w, MSG.techError, 'error'); });
    });
  }

  // Revalida el código ya aplicado contra el estado actual del carrito
  // (cambios de cantidad/productos). No reenvía el código: Shopify ya lo
  // tiene asociado al carrito; solo refleja si sigue siendo aplicable.
  function resyncFromCart() {
    if (!appliedCode) return;
    fetchCart().then(function (cart) {
      var entry = findEntry(cart, appliedCode);
      if (!entry) {
        appliedCode = null;
        appliedOk = false;
        clearState();
        renderIdle();
        return;
      }
      if (entry.applicable) {
        appliedOk = true;
        renderApplied(appliedCode);
      } else {
        appliedOk = false;
        renderNotApplicable(appliedCode);
      }
    }).catch(function () { /* no-op: se reintentará en el próximo evento de carrito */ });
  }

  // Códigos manuales que el carrito ya trae pero que este widget no rastrea
  // (p.ej. quedaron de la implementación vieja, o de otra sesión). Los quitamos
  // del carrito real para no dejar un estado a medias: mostrado en el carrito
  // pero no leído en el checkout. Solo toca cart.discount_codes (códigos
  // manuales); nunca descuentos automáticos, BOGO ni bundles.
  function purgeOrphanCodes(cart) {
    var list = (cart && cart.discount_codes) || [];
    if (!list.length) return Promise.resolve();
    return setCartDiscount('').then(broadcastCartChange).catch(function () {});
  }

  // ---------- inicialización desde el carrito real (carga/recarga de página) ----------
  function initFromCart() {
    var stored = readState();
    fetchCart().then(function (cart) {
      if (!stored) {
        // Sin registro local vigente: si el carrito trae un código manual que no
        // rastreamos, es un huérfano (ver purgeOrphanCodes) — se quita de verdad.
        purgeOrphanCodes(cart);
        renderIdle();
        return;
      }
      var entry = findEntry(cart, stored.code);
      if (!entry) {
        // Pasaron 24h en otra pestaña, o el carrito ya no lo tiene: limpiar.
        clearState();
        renderIdle();
        return;
      }
      appliedCode = stored.code;
      if (entry.applicable) {
        appliedOk = true;
        renderApplied(stored.code);
      } else {
        appliedOk = false;
        renderNotApplicable(stored.code);
      }
    }).catch(function () { renderIdle(); });

    // Vencimiento real a las 24h: si había un registro pero ya expiró,
    // readState() ya lo trata como "sin registro" (stored=null) más arriba,
    // así que purgeOrphanCodes() se encarga de sacarlo también del carrito real.
    if (!stored) {
      try { if (localStorage.getItem(STORAGE_KEY)) clearState(); } catch (e) {}
    }
  }

  // ---------- construcción del widget (mismo look & feel que el original) ----------
  function buildWidget() {
    var wrap = document.createElement('div');
    wrap.className = 'konko-disc';
    wrap.setAttribute('data-kk-disc', '1');

    var btnInlineStyle = 'background:#111 !important;color:#fff !important;border:none !important;' +
      'padding:6px 10px !important;font-size:11px !important;font-weight:700 !important;' +
      'text-transform:uppercase !important;letter-spacing:0.05em !important;cursor:pointer !important;' +
      'border-radius:3px !important;font-family:inherit !important;line-height:1 !important;' +
      'min-width:68px !important;flex:0 0 auto !important;display:inline-flex !important;' +
      'align-items:center !important;justify-content:center !important;';

    var removeInlineStyle = 'background:transparent !important;color:#666 !important;border:none !important;' +
      'padding:2px 0 !important;font-size:11px !important;text-decoration:underline !important;' +
      'cursor:pointer !important;font-family:inherit !important;';

    wrap.innerHTML =
      '<div class="konko-disc__row">' +
        '<input type="text" class="konko-disc__input" placeholder="Código de descuento" autocomplete="off">' +
        '<button type="button" class="konko-disc__btn" style="' + btnInlineStyle + '">APLICAR</button>' +
      '</div>' +
      '<div class="konko-disc__msg" style="display:block;" role="status" aria-live="polite"></div>' +
      '<button type="button" class="konko-disc__remove" style="' + removeInlineStyle + 'display:none;">Quitar código</button>';

    var input = wrap.querySelector('.konko-disc__input');
    var btn = wrap.querySelector('.konko-disc__btn');
    var msg = wrap.querySelector('.konko-disc__msg');
    var removeBtn = wrap.querySelector('.konko-disc__remove');

    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      applyCode(input.value);
    });
    btn.addEventListener('mouseenter', function () { btn.style.background = '#333'; });
    btn.addEventListener('mouseleave', function () { btn.style.background = '#111'; });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); applyCode(input.value); }
    });
    removeBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      removeCode();
    });

    var w = { root: wrap, input: input, btn: btn, msg: msg, removeBtn: removeBtn };
    widgets.push(w);

    if (appliedCode) {
      if (appliedOk) renderApplied(appliedCode); else renderNotApplicable(appliedCode);
    }

    return wrap;
  }

  // ---------- inserción / limpieza de duplicados y del widget roto externo ----------
  function removeGhostWidgets() {
    // ".konko-disc" sin data-kk-disc="1" es el widget del script externo konko-cro-v11.js
    document.querySelectorAll('.konko-disc:not([data-kk-disc])').forEach(function (el) { el.remove(); });
  }

  function pruneDetachedWidgets() {
    widgets = widgets.filter(function (w) { return document.body.contains(w.root); });
  }

  function ensureWidgetIn(container) {
    if (!container) return;
    if (container.querySelector(':scope > .konko-disc[data-kk-disc]')) return;
    container.insertBefore(buildWidget(), container.firstElementChild || null);
  }

  function syncWidgets() {
    removeGhostWidgets();
    pruneDetachedWidgets();
    var drawerFooter = document.querySelector('#CartDrawer .drawer__footer');
    var cartCol = document.querySelector('.cart__page-col');
    ensureWidgetIn(drawerFooter);
    ensureWidgetIn(cartCol);
  }

  // ---------- arranque ----------
  var syncTimer = null;
  function debouncedSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncWidgets, 150);
  }

  function observeContainers() {
    var observer = new MutationObserver(debouncedSync);
    var watched = false;
    var drawer = document.getElementById('CartDrawer');
    if (drawer) { observer.observe(drawer, { childList: true, subtree: true }); watched = true; }
    var cartPage = document.querySelector('.cart__page-col');
    if (cartPage && cartPage.parentNode) { observer.observe(cartPage.parentNode, { childList: true, subtree: true }); watched = true; }
    return watched;
  }

  function init() {
    syncWidgets();
    initFromCart();

    document.addEventListener('cart:build', function () { syncWidgets(); resyncFromCart(); });
    document.addEventListener('cart:updated', function () { syncWidgets(); resyncFromCart(); });
    document.addEventListener('cart:refresh', function () { syncWidgets(); resyncFromCart(); });

    if (!observeContainers()) {
      // El drawer/página de carrito puede no estar en el DOM aún (theme.liquid
      // los agrega vía footer.liquid). Reintentar con límite, igual que otros
      // scripts del theme (p.ej. kk-drawer-unified), sin observar todo el documento.
      var tries = 0;
      (function waitForContainer() {
        if (observeContainers()) { syncWidgets(); return; }
        if (tries++ < 60) setTimeout(waitForContainer, 250);
      })();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
